import { memo, useMemo } from "react";
import { motion } from "motion/react";

interface StreamingTextProps {
  text: string;
  animate?: boolean;
  delay?: number;
  wordDelay?: number;
  className?: string;
  style?: React.CSSProperties;
  onComplete?: () => void;
}

export const StreamingText = memo(
  ({
    text,
    animate = true,
    delay = 0,
    wordDelay = 0.05,
    className,
    style,
    onComplete,
  }: StreamingTextProps) => {
    const words = useMemo(() => text?.split(" ") ?? [], [text]);

    if (!animate || !text) {
      // Si no hay animación, llamar onComplete inmediatamente
      if (onComplete) {
        setTimeout(onComplete, 0);
      }
      return (
        <span className={className} style={style}>
          {text}
        </span>
      );
    }

    const isLastWord = (index: number) => index === words.length - 1;

    return (
      <span className={className} style={{ ...style, display: "inline" }}>
        {words.map((word, index) => (
          <motion.span
            key={`${word}-${index}`}
            initial={{ opacity: 0, filter: "blur(4px)" }}
            animate={{ opacity: 1, filter: "blur(0px)" }}
            transition={{
              duration: 0.3,
              delay: delay + index * wordDelay,
              ease: "easeOut",
            }}
            style={{ display: "inline-block", marginRight: "0.25em" }}
            onAnimationComplete={isLastWord(index) ? onComplete : undefined}
          >
            {word}
          </motion.span>
        ))}
      </span>
    );
  }
);

StreamingText.displayName = "StreamingText";
